<template>
    <div class="container-fluid">
        <!-- display component heading -->
        <div class="row">
            <div class="col-sm-10 col-12 px-0 add-ellipsis">
                <router-link :to="{ name: 'home' }" class="h4">
                    <i class="fas fa-layer-group"></i> <span class="text-dark-green"> Explore Other Categories</span> 
                </router-link>
            </div>
            <div class="col-sm-2 px-0 text-right d-none d-sm-block">
                <router-link :to="{ name: 'home' }">
                    <button class="btn btn-dark-green btn-sm">See All</button>
                </router-link>
            </div>
        </div>

        <!-- category icons -->
        <div class="mx-n3">
            <app-icons :excludeCategory="displayedCategory" :exploreCategory="true"></app-icons>
        </div>
    </div>
</template>

<script>
import Icons from '../homeParts/Icons.vue'

export default {
    name: "MoreCategories",
    props: {
        displayedCategory: {
            type: String,
            required: false
        }
    },
    components: {
        appIcons: Icons
    },
}
</script>
